/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
function n(n,r,t,u){return n.x=n.x+r,n.y=n.y+t,null!=u&&(n.z=(n.z??0)+u),n}function r(n,r){return n[0]+=r,n}export{r as offsetCoordsX,n as offsetPoint};
